.fp-vertical-spacing
  .fp-vertical-spacing--line(v-for='toast in toasts' :key='toast.id')
    ToastVue(:toast='toast' data-test='toasts' @closed='remove(toast.id)')
